export type ApiTokenScopeOption = {
  id: string
  name: string
}

export const API_TOKEN_REGISTRATION_SCOPES: ApiTokenScopeOption[] = [
  { id: 'read', name: 'Read' },
  { id: 'write', name: 'Write' },
  { id: 'delete', name: 'Delete' }
]

export const API_TOKEN_EVENT_SCOPES: ApiTokenScopeOption[] = [{ id: 'read', name: 'Read' }]
